<template id="cp-add">
  <div class="maxw">
    <h1>Nou Producte-Client</h1>
    <b-form v-on:submit.prevent="addCP">
      <b-row>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Client:*"
            label-for="input-nif"
          >
            <b-form-select
              id="select-clients"
              autofocus
              v-model="form.ClienteIdentifier"
              :options="clientes"
              value-field="identifier"
              text-field="nombre"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Producte:*"
            label-for="input-nif"
          >
            <b-form-select
              id="select-products"
              v-model="form.ProductoIdentifier"
              :options="productes"
              value-field="identifier"
              text-field="nombre"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label="Descripció:">
            {{
              this.productes.find(
                (x) => x.identifier === form.ProductoIdentifier
              ).descripcion
            }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label="Unitats:">
            {{
              this.productes.find(
                (x) => x.identifier === form.ProductoIdentifier
              ).unitats
            }}
          </b-form-group>
        </b-col>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label="Preu Unitat:">
            {{
              this.productes.find(
                (x) => x.identifier === form.ProductoIdentifier
              ).precio
            }}
          </b-form-group>
        </b-col>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label="Preu Base:">
            {{ calculaPreu }}
          </b-form-group>
        </b-col>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label="Dte: (%)">
            {{
              this.productes.find(
                (x) => x.identifier === form.ProductoIdentifier
              ).descuento
            }}
          </b-form-group>
        </b-col>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label-class="font-weight-bold" label="Descompte: (€)">
            {{ calculaDescompte }}
          </b-form-group>
        </b-col>
        <b-col v-if="form.ProductoIdentifier !== null">
          <b-form-group label-class="font-weight-bold" label="Import: (€)">
            {{ calculaImport }}
          </b-form-group>
        </b-col>
      </b-row>
      <hr
        style="
          height: 2px;
          border-width: 0;
          color: gray;
          background-color: gray;
        "
      />
      <b-row>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Titol Producte:*"
            label-for="input-titol"
          >
            <b-form-input
              id="input-titol"
              v-model="form.ProductoTitulo"
              required
              maxlength="100"
              placeholder="Escriure nom del producte pel Client."
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Descripció FACTURA:"
            label-for="textarea-descripcion"
          >
            <b-form-textarea
              id="textarea-descripcion"
              v-model="form.ProductoDescripcion"
              placeholder="Escriure descripció per a la factura."
              rows="4"
              max-rows="4"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-form-group
            label="Unitats:"
            label-class="font-weight-bold"
            label-for="input-unit"
          >
            <b-form-input
              type="number"
              :number="true"
              required
              id="input-unit"
              v-model="form.ProductoUnidades"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Preu:(€)*"
            label-for="input-preu"
          >
            <b-form-input
              type="number"
              :number="true"
              step="0.01"
              min="0.00"
              id="input-preu"
              required
              v-model="form.ProductoPrecio"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Preu Base: (€)">
            {{ calculaPreuNou }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Descompte:(%)"
            label-for="input-dte"
          >
            <b-form-input
              type="number"
              :number="true"
              step="0.10"
              min="0.00"
              id="input-dte"
              v-model="form.ProductoDescuento"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Dte(€):">
            {{ calculaDescompteNou }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Import(€):">
            {{ calculaImportNou }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Periode Facturació:(dies)*"
            label-for="input-periode"
          >
            <b-form-input
              id="input-periode"
              v-model="form.ProductoDiasFacturacion"
              type="number"
              :number="true"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-class="font-weight-bold"
            label="Repetitiu:"
            label-for="input-rep"
          >
            <b-form-checkbox
              v-model="form.isRecurrente"
              name="check-button"
              switch
            >
              Facturació Recurrent (vs Unica)
              <b>(Checked: {{ form.isRecurrente }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <b-col></b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit"
            >Gravar</b-button
          >
          <b-button class="mr-2" variant="outline-primary"
            ><router-link :to="{ name: 'CPs' }">Cancel</router-link></b-button
          >
        </b-col>
        <b-form-input
          :hidden="true"
          type="text"
          v-model="form.ProductoImporte"
        ></b-form-input>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  data () {
    return {
      loading: true,
      productes: [],
      clientes: [],
      form: {
        ClienteIdentifier: null,
        ProductoTitulo: null,
        ProductoDescripcion: "TITULO:Centro;SUBTITULO:Taller <nombre_taller>;CONCEPTO:Acceso y uso plataforma periodo Factura\r\nTITULO:Licenciamiento;SUBTITULO:Licencia Microsoft Power BI Pro;CONCEPTO:Licencia usuario\r\nUsuario usuario@idealiveconsulting.com",
        ProductoPrecio: 0,
        ProductoUnidades: 0,
        ProductoImporte: 0,
        ProductoDiasFacturacion: 30,
        ProductoDescuento: 0,
        ProductoIdentifier: null,
        isRecurrente: true
      }
    }
  },
  computed: {
    calculaPreu: function () {
      return (
        this.productes.find(
          (x) => x.identifier === this.form.ProductoIdentifier
        ).precio *
          this.productes.find(
            (x) => x.identifier === this.form.ProductoIdentifier
          ).unitats
      )
    },
    calculaDescompte: function () {
      return (
        -this.calculaPreu *
          (this.productes.find(
            (x) => x.identifier === this.form.ProductoIdentifier
          ).descuento /
            100)
      )
    },
    calculaImport: function () {
      return this.calculaPreu + this.calculaDescompte
    },
    calculaPreuNou: function () {
      return this.form.ProductoUnidades * this.form.ProductoPrecio
    },
    calculaDescompteNou: function () {
      return -this.calculaPreuNou * (this.form.ProductoDescuento / 100)
    },
    calculaImportNou: function () {
      return this.calculaPreuNou + this.calculaDescompteNou
    }
  },
  created () {
    (async () => {
      await DataAccess.getDataMuliplex2('/api/clients', '/api/products')
        .then((responses) => {
          // const responseOne = responses[0]
          // const responseTwo = responses[1]
          this.clientes = responses[0].data
          this.productes = responses[1].data
          this.loading = false
        })
        .catch((error) => {
          console.log('ERROR: ', error)
        })
    })()
  },
  methods: {
    addCP (evt) {
      (async () => {
        await DataAccess.postData('/api/clientProd', JSON.stringify(this.form))
          .then((response) => {
            this.$router.push({ name: 'CPs' })
          })
          .catch((error) => {
            console.log(JSON.stringify(this.form))
            console.log('ERROR: ', error)
          })
      })()
    },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.nombre = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
